/**
 * 從「分享／回覆文字」中移除品牌廣告行
 * 用於 Join 頁分享文字，確保用戶分享內容不出現廣告文（即使用戶回覆格式中曾存有廣告句）
 */

/** 判斷單行是否為品牌廣告句 */
function isBrandAdLine(line: string): boolean {
  const t = String(line ?? '').trim();
  if (!t) return false;
  return (
    t.includes('減壹加') ||
    t.includes('減一加') ||
    t.includes('活動秘書') ||
    t.includes('活動 秘書') ||
    (t.includes('團購') && t.includes('球隊') && t.includes('烘焙')) ||
    /減[壹一]加/.test(t) ||
    /活動\s*秘書/.test(t)
  );
}

/**
 * 從整段分享文字中移除品牌廣告行（依換行拆行後過濾，再合併）
 * @param text 原始分享文字（可能含 prefix、主文、suffix、連結）
 * @returns 移除廣告行後的文字，若結果為空字串則回傳空字串（呼叫端可 fallback 為「已送出」等）
 */
export function stripBrandAdFromShareText(text: string): string {
  if (text == null || String(text).trim() === '') return '';
  const lines = String(text).split('\n');
  const filtered = lines.filter(line => !isBrandAdLine(line));
  return filtered.join('\n').trim();
}
